import { render } from "./CajaApertura.vue?vue&type=template&id=16904a0f&scoped=true"
import script from "./CajaApertura.vue?vue&type=script&lang=js"
export * from "./CajaApertura.vue?vue&type=script&lang=js"

import "./CajaApertura.vue?vue&type=style&index=0&id=16904a0f&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_restaurante\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16904a0f"]])

export default __exports__